import profileCart from "../loadModules/profileCart";
import HelpMore from "../loadModules/helpMore";
import ModifyAddress from "../loadModules/modifyAddress";
import DeleteOrder from "../loadModules/deleteOrder";
import Refound from "../loadModules/refound";

const Help = {
    data() {
        return {
            loaded: false,
            orderPage: false,
            module: null,
            modules: {},
            showFirstTab:false,
            showSecondTab:false,
            showSuccessTab:false,
            showErrorTab:false,
            errorMessage:"",
            chooseOrder:{},
            orders:{},
            isProductReturn: false,
            isProductChange: false,
            isDispute: false,
            recentOrders:[],
            pendingOrders:[],
            withdrawOrders:[],
            lan:window.lan,
            instantSuccess: false,
            pendingReturn: null,

            paymentData: null,
            finishPaymentEvent: null,
            finishPaymentButtonEvent: null,
            startPaymentEvent: null,
            initializePaymentButtonEvent: null,
            paymentButtonClientId: null,
            paymentError: null,
            successfulPayment: false,
            backModule: null,
            backed: false,
            helpChangeEnabled: false,
            helpReturnEnabled: false,
            helpWarehouseCountry: null,
        };
    },
    computed:{
        canModifyOrder(){
            return this.chooseOrder &&
                (this.chooseOrder.status === null || this.chooseOrder.status === 0) &&
                this.chooseOrder.order_items_sum_quantity > 0 &&
                this.chooseOrder.accepted == null;
        },
        canChangeItems(){
            return this.canChangeOrderAfterDelivery && this.helpChangeEnabled;
        },
        canChangeSize(){
            return this.canChangeOrderAfterDelivery && this.helpChangeEnabled;
        },
        canStartReturn(){
            return this.canChangeOrderAfterDelivery && this.chooseOrder?.allow_return && this.helpReturnEnabled;
        },
        canStartDispute(){
            return this.canChangeOrderAfterDelivery && !this.chooseOrder.allow_return && this.helpReturnEnabled;
        },
        canChangeOrderAfterDelivery(){
            const delivery = this.chooseOrder?.orderDeliveries?.[0];
            return this.chooseOrder?.status > 0 &&
                this.chooseOrder?.accepted &&
                this.chooseOrder?.order_items_sum_quantity > 0 &&
                (this.chooseOrder?.delivered_status > 5 ||
                    (delivery?.tracking_code_created_at && Date.parse(delivery.tracking_code_created_at) < Date.now() - 86400000));
        },
        trackingCode(){
            if(!this.chooseOrder){
                return null;
            }
            return this.chooseOrder?.orderDeliveries[this.chooseOrder?.orderDeliveries.length-1]?.public_tracking_code
        },
    },
    methods: {
        /* payments */
        loadScript(script, after = null,event=null) {
            const _this = this;
            const tag = document.createElement("script");
            tag.src = script;
            if (after !== undefined && after !== null) {
                tag.onload = () => {
                    _this.loadScript(after,null,event);
                };
            }else if (event !== undefined && event !== null) {
                tag.onload = () => {
                    event();
                };
            }
            document.getElementsByTagName("body")[0].appendChild(tag);
        },
        initializePaymentButton(event) {
            this.initializePaymentButtonEvent = event;
        },
        startInitializePaymentButton() {
            if(this.initializePaymentButtonEvent !== null){
                this.initializePaymentButtonEvent({
                    price: this.totalPrice,
                    currency_code: currency,
                    client_id: this.paymentButtonClientId
                });
            }
        },
        startPayment(event) {
            this.startPaymentEvent = event;
            this.startPaymentCall();
        },
        startPaymentCall() {
            const paymentInfo = this.paymentData?.original?.data ?? this.paymentData?.data ?? this.paymentData;
            if(this.startPaymentEvent !== null && paymentInfo?.payment_method_id !== undefined){
                this.startPaymentEvent(paymentInfo,"payment-element");
                this.pageLoading = false;
            }
        },
        finishPaymentButton(event) {
            this.finishPaymentButtonEvent = event;
            this.payment = payment_button.id;
            this.finishOrder();
        },
        callFinishPaymentButton() {
            const paymentInfo = this.paymentData?.original?.data ?? this.paymentData?.data ?? this.paymentData;
            this.isInputLoding = true;
            this.finishPaymentButtonEvent(paymentInfo).then(data => {
               // this.step = 5;
                this.pageLoading = false;
                this.isInputLoding = false;
                this.items = [];
                this.updateLocalStorage();
            }).catch(error => {
                this.paymentError = error.message;
              //  this.pageLoading = false;
                this.isInputLoding = false;
            });
        },
        finishPayment(event) {
            this.finishPaymentEvent = event;
        },
        callFinishPayment() {
            try {
                this.isInputLoding = true;
                if (this.finishPaymentEvent === null || this.finishPaymentEvent === undefined) {
                    this.paymentError = "Please make a payment!";
                    this.isInputLoding = false;
                    return;
                }
                this.finishPaymentEvent().then(data => {
                    //   this.step = 5;
                    this.isInputLoding = false;
                    this.successfulPayment = true;
                }).catch(error => {
                    this.paymentError = error.message;
                    this.isInputLoding = false;
                });
            }catch (e){
                this.paymentError = "Please make a payment!";
                this.isInputLoding = false;
            }
        },

        initPayment(id,payment,amount=null) {
            fetch("/api/orders/" + id + "/payment", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({
                    payment_method: payment,
                    amount: amount,
                    token:Cookies.getItem('login_token')
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.code !== 200) {
                        this.errorPaymentMethod = data.message;
                    //    this.pageLoading = false;
                        return;
                    }

                    if(data?.payment === undefined || data?.payment === null){
                        this.errorPaymentMethod = data.message;
                        this.pageLoading = false;
                        return;
                    }

                  //  this.step = 4;
                    this.paymentData = data.payment;

                    if (data?.script?.url !== undefined && data?.script?.url !== null && data?.script?.script !== undefined && data?.script?.script !== null && data?.script?.url !== "") {
                        this.loadScript(data.script.url, "/api/script/" + data.script.id + ".js");
                    } else if (data?.script?.url !== undefined && data?.script?.url !== null && data?.script?.url !== "") {
                        this.loadScript(data.script.url);
                    } else if (data?.script?.script !== undefined && data?.script?.script !== null) {
                        this.loadScript("/api/script/" + data.script.id + ".js");
                    }else{
                        //this.pageLoading = false;
                        //this.step = 5;
                    }
                }).catch(() => {
                    this.paymentError = "Please make a payment!";
                    this.isInputLoding = false;
                });
        },


        chooseOrderHelper(order){
            // the page has the order manage dialog: the same flow as the Orders page
            if (window.OrderManage && OrderManage.available()) {
                OrderManage.open(order, 'menu');
                return;
            }
            // legacy help modules, for themes without the dialog markup
            this.orderPage = true;
            this.chooseOrder=order;

            this.enableFirstTab();
        },
        back(){
            if(this.module === null) {
                this.orderPage = false;
            }else {
                document.getElementById(this.module).style.display = 'none';
                this.module = null;
            }
        },
        enableFirstTab(){
            this.showFirstTab=true;
            this.showSecondTab=false;
        },
        enableSecondTab(){
            this.showSecondTab=true;
            this.showFirstTab=false;
        },
        existTab(){
            this.showFirstTab=false;
            this.showSecondTab=false;
            this.showSuccessTab=false;
            this.showErrorTab=false;
        },
        alert(massage) {
            this.errorMessage = massage;
            this.showFirstTab=false;
            this.showSecondTab=false;
            this.showSuccessTab=false;
            this.showErrorTab=true;
        },
        successTab() {
            if(this.backModule !== null){
                this.module = this.backModule;
                this.backed = true;
                this.backModule = null;
                return;
            }
            this.backed = false;
            this.showFirstTab=false;
            this.showSecondTab=false;
            this.showSuccessTab=true;
            this.showErrorTab=false;
        },
        loadModule(name,isProductReturn=false,isProductChange=false,isDispute=false){
            if(name === 'profileCart'){
                this.backed = false;
                this.pendingReturn = null;
                this.instantSuccess = false;
            }
            this.module = name;
            this.isProductChange = isProductChange;
            this.isProductReturn = isProductReturn;
            this.isDispute = isDispute;

            this.enableSecondTab();
        },
        async fetchOrders(){
            let loginToken = Cookies.getItem("login_token");
            if(!loginToken){
                this.loaded = true;
                return;
            }
          const response= await fetch(`/api/orders`,{
            method:"POST",
            headers:http.headers(),
            body:JSON.stringify({token: loginToken})
          })

          const orders=await response.json();

          if(orders.code!==200){
              this.loaded = true;
              return;
          }

          const {recent_orders,pending_orders,refund_orders}= orders.data;

          let orderStatus = {};
          for (const order of orders.data.all_orders.data) {
              orderStatus[order.id] = order.allow_return;
          }
          for (const order of recent_orders) {
              order.allow_return = orderStatus[order.id];
          }
          for (const order of pending_orders) {
              order.allow_return = orderStatus[order.id];
          }
          for (const order of refund_orders) {
              order.allow_return = orderStatus[order.id];
          }

          this.recentOrders=recent_orders;
          this.pendingOrders=pending_orders;
          this.withdrawOrders=refund_orders;

          const url = new URL(location.href);
          let id = url.searchParams.get("id");
          if(id !== undefined && id !== null) {
              let order = orders.data.pending_orders.find((e) => e.id == id);
              if(order === undefined) {
                  order = orders.data.recent_orders.find((e) => e.id == id);
              }
              if(order === undefined) {
                  order = orders.data.refund_orders.find((e) => e.id == id);
              }
              if(order !== undefined) {
                  this.chooseOrderHelper(order);
              }
          }
          this.loaded = true;
        },
        handleRefresh(){
            this.existTab();
            this.fetchOrders();
        }
    },
    mounted(){
      const helpElement = document.getElementById('help');
      this.helpChangeEnabled = helpElement?.dataset.helpChangeEnabled === 'true';
      this.helpReturnEnabled = helpElement?.dataset.helpReturnEnabled === 'true';
      this.helpWarehouseCountry = helpElement?.dataset.helpWarehouseCountry;
      // a change in the order manage dialog: the lists show the new state
      document.addEventListener('order-manage:done', () => this.fetchOrders());
      this.fetchOrders();
    }
};


const HELP = {
    vue: null,
    load() {
        if(document.getElementById('help') !== null) {
            if(typeof Vue === "undefined"){
                setTimeout(HELP.load,400);
                return;
            }
            HELP.vue = Vue.createApp(Help)
            .component('profile-cart',profileCart)
            .component('modify-products', profileCart)
            .component('help-more',HelpMore)
            .component('modify-address',ModifyAddress)
            .component('address-fields',AddressFields)
            .component('delete-order',DeleteOrder)
            .component('refound',Refound)
            .mount('#help');
        }
    },
};
window.HELP = HELP;

window.addEventListener('DOMContentLoaded', () => {
    HELP.load();
});

if (document.readyState !== 'loading') {
    HELP.load();
}


// Global Order object
const CART = {
    initializePaymentButton(event) {
        //return HELP.vue.initializePaymentButton(event);
    },
    startPayment(event) {
        return HELP.vue.startPayment(event);
    },
    finishPayment(event) {
        return HELP.vue.finishPayment(event);
    },
    finishPaymentButton(event) {
        return HELP.vue.finishPaymentButton(event);
    },
};
window.CART = CART;
